export default __webpack_public_path__ + "static/media/music_note.b52ebf7e.svg";